import React, { useEffect, useState, useCallback } from 'react'
import { mostrarToast, mostrarToastWebService } from './Toasts';
import { toast } from 'react-toastify';
import { get } from '../util/AcessoApi';
import { mensagens } from '../util/Utilitarios';
import { BtnAcao } from './Acoes';
import { forceDownload } from '../util/FuncoesComuns';
import { SERVICE } from '../util/Enums';
import { getUsuario, URL_BACKEND } from '../util/Configuracoes'
const AWS = require('aws-sdk');
const { Consumer } = require('sqs-consumer');
// const { Consumer } = require('sqs-consumer');

AWS.config.update({
    region: process.env.REACT_APP_SERVICES_AWS_REGION,
    accessKeyId: process.env.REACT_APP_SERVICES_AWS_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_SERVICES_AWS_SECRET_ACCESS_KEY
});

const WebService = React.forwardRef((props, ref) => {
    const [messageQueue, setMessageQueue] = useState('Aguarde...')
    const [showBtn, setShowBtn] = useState(true)
    let funcaoDownloadOK = () => { }

    const Msg = (obj) => {
        return (
            <div>
                <h6>
                    <b>{obj.obj.title}</b>
                </h6>
                <span>{obj.obj.subtitle}</span>
            </div>
        )
    }

    const openSseStream = (processId, onMessage, onError) => {
        const user = getUsuario?.()
        const token = (user && user.token) || ''

        const streamUrl = `${URL_BACKEND || ''}/sse-queue/stream/${processId}?token=${encodeURIComponent(
            token
        )}`

        const es = new EventSource(streamUrl)

        es.addEventListener('message', (e) => {
            try {
                const obj = JSON.parse(e.data)
                onMessage(obj)
            } catch {
                // ignore
            }
        })

        es.addEventListener('done', () => {
            es.close()
        })

        es.addEventListener('error', () => {
            try {
                es.close()
            } catch { }
            onError()
        })

        return es
    }

    const handleClick = useCallback((body, serviceToCall, funcSuccess) => {
        const toastify = toast('Aguarde...', { isLoading: true })

        const obj = JSON.parse(body)

        const bodyToSend = JSON.stringify({
            service_call: serviceToCall ?? SERVICE.ENGINE_INTEGRATION,
            ...JSON.parse(body)
        })

        const objPermissao = {
            modulo_id: obj.moduloId,
            acao_id: obj.acaoId,
            usuario_id: obj.usuarioId,
        }

        get('/controleAcesso/permissao', objPermissao)
            .then(function (val) {
                if (!val.length) {
                    toast.update(toastify, {
                        autoClose: 5000,
                        type: 'error',
                        render: mensagens['permissao'],
                        isLoading: false,
                        progress: 0,
                    })
                    return
                }

                const user = getUsuario?.()
                const token = (user && user.token) || ''

                fetch(`${URL_BACKEND || ''}/sse-queue/start`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: token,
                    },
                    body: bodyToSend,
                })
                    .then((response) => response.json())
                    .then((result) => {
                        const processId = result.processId
                        if (!processId) throw new Error('processId inválido')

                        funcaoDownloadOK = (objRetorno) => funcSuccess(objRetorno)
                        setShowBtn(false)

                        toast.update(toastify, {
                            render: 'Aguarde...',
                            toastId: processId,
                            isLoading: true,
                        })

                        // ✅ 2) abre SSE e recebe as mensagens em tempo real
                        openSseStream(
                            processId,
                            (objRetorno) => {
                                setMessageQueue(JSON.stringify(objRetorno))

                                const progress = parseInt(objRetorno?.progress ?? '0', 10)

                                if (objRetorno.download === 'True' && objRetorno.url) {
                                    toast.update(objRetorno.processId || processId, {
                                        autoClose: 5000,
                                        type: objRetorno.type,
                                        render: <Msg obj={objRetorno} />,
                                        isLoading: false,
                                        progress: 0,
                                    })
                                    forceDownload(objRetorno.url, objRetorno.fileName)
                                    funcaoDownloadOK()
                                    return
                                }

                                switch (objRetorno.type) {
                                    case 'error':
                                    case 'success':
                                    case 'info':
                                        toast.update(objRetorno.processId || processId, {
                                            autoClose: 5000,
                                            type: objRetorno.type,
                                            render: <Msg obj={objRetorno} />,
                                            isLoading: false,
                                            progress: 0,
                                        })
                                        funcaoDownloadOK(objRetorno)
                                        break
                                    default:
                                        toast.update(objRetorno.processId || processId, {
                                            progress: progress / 100,
                                            render: <Msg obj={objRetorno} />,
                                            type: objRetorno.type,
                                        })
                                        break
                                }
                            },
                            () => {
                                toast('Ocorreu um erro inesperado. Tente novamente mais tarde.', {
                                    autoClose: 5000,
                                    type: 'error',
                                    toastId: processId,
                                })
                            }
                        )
                    })
                    .catch((error) => {
                        console.log('error', error)
                        toast.update(toastify, {
                            autoClose: 5000,
                            type: 'error',
                            render: mensagens['erro'],
                            isLoading: false,
                            progress: 0,
                        })
                    })
            })
            .catch(() => mostrarToast('erro', mensagens['erro']))
    }, [])

    const handleClickNoQueue = useCallback((body, _serviceToCall, config) => {
        const toastify = toast("Aguarde...", { isLoading: true });
        const obj = JSON.parse(body);

        const bodyToSend = JSON.stringify({
            service_call: _serviceToCall ?? SERVICE.ENGINE_INTEGRATION,
            ...JSON.parse(body)
        })

        const objPermissao = {
            modulo_id: obj.moduloId,
            acao_id: obj.acaoId,
            usuario_id: obj.usuarioId,
        };

        get("/controleAcesso/permissao", objPermissao)
            .then(async (val) => {
                if (!val.length) {
                    toast.update(toastify, {
                        autoClose: 5000,
                        type: "error",
                        render: mensagens["permissao"],
                        isLoading: false,
                        progress: 0,
                    });
                    return;
                }

                toast.update(toastify, {
                    autoClose: config.tempo || 5000,
                    type: "info",
                    render: <Msg obj={{ title: config.titulo, subtitle: config.mensagem }} />,
                    isLoading: false,
                });

                const user = getUsuario?.();
                const token = (user && user.token) || "";
                const baseUrl = SERVICE.URL_BACKEND || "";

                try {
                    const r = await fetch(`${baseUrl}/sse-queue/start`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: token,
                        },
                        bodyToSend,
                    });

                    if (!r.ok) {
                        console.log("Falha ao disparar processo:", await r.text().catch(() => ""));
                    }

                } catch (e) {
                    console.log("Erro ao chamar backend start:", e);
                }
            })
            .catch(() => mostrarToast("erro", mensagens["erro"]));
    }, []);
    if (ref) {
        ref.current = {
            processar: handleClick,
            processarSemFila: handleClickNoQueue,
        }
    }

    return null
})

const WebServiceNoToast = React.forwardRef((props, ref) => {
    const Msg = (obj) => {
        return (
            <div>
                <h6>
                    <b>{obj.title}</b>
                </h6>
                <span>{obj.content}</span>
            </div>
        )
    }

    const [messageQueue, setMessageQueue] = useState("Aguarde...");
    const [showBtn, setShowBtn] = useState(true);
    let funcaoDownloadOK = () => { };

    // SSE helper
    const openSseStream = (processId, onMessage, onError) => {
        const user = getUsuario?.();
        const token = (user && user.token) || "";

        const baseUrl = URL_BACKEND || ""; // ajuste se necessário
        const url = `${baseUrl}/sse-queue/stream/${processId}?token=${encodeURIComponent(
            token
        )}`;

        const es = new EventSource(url);

        es.addEventListener("message", (e) => {
            try {
                const obj = JSON.parse(e.data);
                onMessage(obj);
            } catch {
                // ignore
            }
        });

        es.addEventListener("done", () => {
            es.close();
        });

        es.addEventListener("error", () => {
            try {
                es.close();
            } catch { }
            onError();
        });

        return es;
    };

    const handleClick = useCallback((body, serviceToCall, funcSuccess) => {
        const toastify = toast('Aguarde...', { isLoading: true })
        const obj = JSON.parse(body);

        const objPermissao = {
            modulo_id: obj.moduloId,
            acao_id: obj.acaoId,
            usuario_id: obj.usuarioId,
        };

        const bodyToSend = JSON.stringify({
            service_call: serviceToCall ?? SERVICE.ENGINE_INTEGRATION,
            ...JSON.parse(body)
        })

        get("/controleAcesso/permissao", objPermissao)
            .then(function (val) {
                if (!val.length) return;

                const user = getUsuario?.();
                const token = (user && user.token) || "";

                const baseUrl = URL_BACKEND || "";

                fetch(`${baseUrl}/sse-queue/start`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: token,
                    },
                    body: bodyToSend,
                })
                    .then((r) => r.json())
                    .then((result) => {
                        const processId = result?.processId;
                        if (!processId) throw new Error("processId inválido");

                        funcaoDownloadOK = (objRetorno) => funcSuccess(objRetorno);
                        setShowBtn(false);

                        toast.update(toastify, {
                            type: 'Info',
                            render: <Msg title='Iniciando Processamento...' content='Processamento Iniciado com sucesso.' />,
                            toastId: processId,
                            isLoading: false,
                            autoClose: 5000
                        })

                        openSseStream(
                            processId,
                            (objRetorno) => {
                                setMessageQueue(JSON.stringify(objRetorno));

                                // download
                                if (objRetorno.download === "True" && objRetorno.url) {
                                    forceDownload(objRetorno.url, objRetorno.fileName);
                                    funcaoDownloadOK(objRetorno);
                                    return;
                                }

                                // finalizações
                                switch (objRetorno.type) {
                                    case "error":
                                    case "success":
                                    case "info":
                                        funcaoDownloadOK(objRetorno);
                                        break;
                                    default:
                                        break;
                                }
                            },
                            () => {
                                toast("Ocorreu um erro inesperado no envio de Guia. Tente novamente mais tarde.", {
                                    autoClose: 5000,
                                    type: "error",
                                    toastId: processId,
                                });
                            }
                        );
                    })
                    .catch((err) => {
                        console.log("error", err);
                        mostrarToast("erro", mensagens["erro"]);
                    });
            })
            .catch(() => mostrarToast("erro", mensagens["erro"]));
    }, []);

    if (ref) {
        ref.current = {
            processar: handleClick,
        };
    }

    return null;
});

export default WebService;

export { WebServiceNoToast }
